module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flash"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "flash-background",
    on: {
      "click": _vm.close
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-top"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "flash-content"
  }, [(_vm.headline !== '') ? _c('div', {
    staticClass: "head"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.content) ? _c('div', {
    staticClass: "body",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d22f5bb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Flash.vue
// module id = 465
// module chunks = 234